export const useEmulators = process.env.REACT_APP_USE_EMULATORS || false;
